import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { DashboardWrapper, Card, Text } from 'src/shared';
import { Colors } from 'src/utils/color';
import { Size } from 'src/shared/text';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 65px);
    padding: 24px;
`;

const Panel = styled(Card)`
    max-width: 520px;
    width: 100%;
    padding: 24px;
    text-align: left;
    height: auto; /* fit content instead of filling parent */
`;

const Row = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

const Badge = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #fee2e2;
    color: #dc2626;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
`;

const NotFound: FunctionComponent = () => {
    return (
        <DashboardWrapper>
            <Container>
                <Panel>
                    <Row>
                        <Badge>!</Badge>
                        <div>
                            <Text fontSize={Size.Medium} fontWeight="600" color={Colors.extra.black}>
                                404 Page Not Found
                            </Text>
                            <Text fontSize={Size.Small} color={Colors.extra.dark_gray} marginTop={8}>
                                Did you forget to add the page to the router?
                            </Text>
                        </div>
                    </Row>
                </Panel>
            </Container>
        </DashboardWrapper>
    );
};

export default NotFound;


